import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
import styles from './AltSkuField.module.less';
function AltSkuField(props) {
    const { value, className } = props;
    return (_jsx("p", { className: cls(styles.altSkuField, className), title: value, children: value }));
}
export default memo(AltSkuField);
